import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function CostComparison() {
  const comparisonRows = [{
    sin: 'Armás planificaciones desde cero',
    perdes: 'Fines de semana que no volvés a recuperar'
  }, {
    sin: 'Evaluaciones siempre iguales',
    perdes: 'Alumnos que filtran los exámenes entre sí'
  }, {
    sin: 'Sin material de hidrógeno verde o biogás',
    perdes: 'Quedás desactualizado frente a tus alumnos'
  }, {
    sin: 'Sin actividades listas para imprimir',
    perdes: 'Clases desorganizadas que pierden tiempo real'
  }, {
    sin: 'Sin secuencia didáctica',
    perdes: 'Alumnos que no conectan los temas entre sí'
  }, {
    sin: 'Sin clave de corrección',
    perdes: 'Corregís evaluaciones a criterio variable'
  }, {
    sin: 'Sin planificación anual',
    perdes: 'Empezás de cero cada año aunque el programa sea igual'
  }, {
    sin: 'Sin material visual',
    perdes: 'Clases expositivas que pierden la atención del aula'
  }];
  return <section className="py-20 bg-[#0c241a] text-white" data-id="element-18">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-19">
        <div className="text-center mb-12" data-id="element-20">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4" data-id="element-21">
            ⚖️ EL COSTO DE NO TENERLO
          </h2>
        </div>

        <div className="bg-[#06140d]/60 rounded-2xl p-6 md:p-10 border border-[#1a3d2c] mb-12 max-w-3xl mx-auto" data-id="element-22">
          <div className="grid grid-cols-2 gap-4 mb-6 pb-4 border-b border-[#1a3d2c]" data-id="element-23">
            <div className="font-bold text-slate-400 uppercase text-sm tracking-wider" data-id="element-24">
              Sin el Megapack
            </div>
            <div className="font-bold text-red-400 uppercase text-sm tracking-wider" data-id="element-25">
              Lo que realmente perdés
            </div>
          </div>
          <ul className="space-y-6" data-id="element-26">
            {comparisonRows.map((row, i) => <li key={i} className="grid grid-cols-2 gap-4 items-center" data-id="element-27">
                <div className="flex items-start gap-3" data-id="element-28">
                  <div className="mt-1 bg-[#1a3d2c] p-1 rounded-full shrink-0 border border-[#2a5a40]" data-id="element-29">
                    <X className="w-4 h-4 text-slate-400" data-id="element-30" />
                  </div>
                  <span className="text-slate-300 text-sm md:text-base" data-id="element-31">
                    {row.sin}
                  </span>
                </div>
                <div className="text-red-300/90 text-sm md:text-base font-medium" data-id="element-32">
                  {row.perdes}
                </div>
              </li>)}
          </ul>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center bg-gradient-to-br from-[#0c241a] to-[#1a3d2c] rounded-2xl p-8 md:p-12 shadow-2xl border border-slate-400/30" data-id="element-33">
          <p className="md:text-3xl font-black text-white text-[20px] mb-6" data-id="element-34">
            📗🇦🇷 "La próxima clase que des, podés llegar con la planificación
            lista, las actividades impresas y las evaluaciones armadas. O podés
            seguir improvisando."
          </p>
        </motion.div>
      </div>
    </section>;
}